/* JNH Ambassador landing — scroll reveal + smooth in-page nav */
(function () {
  function init(root) {
    if (!root) return;

    var items = root.querySelectorAll('.jnh-reveal');
    if ('IntersectionObserver' in window && items.length) {
      var io = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            if (entry.isIntersecting) {
              entry.target.classList.add('is-visible');
              io.unobserve(entry.target);
            }
          });
        },
        { threshold: 0.12, rootMargin: '0px 0px -8% 0px' }
      );
      items.forEach(function (el) { io.observe(el); });
    } else {
      items.forEach(function (el) { el.classList.add('is-visible'); });
    }

    // Smooth scroll for in-page anchors, accounting for the sticky header.
    root.querySelectorAll('a[href^="#"]').forEach(function (link) {
      link.addEventListener('click', function (e) {
        var id = link.getAttribute('href');
        if (id.length < 2) return;
        var target = root.querySelector(id);
        if (!target) return;
        e.preventDefault();
        var header = root.querySelector('.jnh-header');
        var offset = header ? header.offsetHeight + 12 : 0;
        var top = target.getBoundingClientRect().top + window.pageYOffset - offset;
        window.scrollTo({ top: top, behavior: 'smooth' });
      });
    });

    // Cap the hero background so it ends at the gallery's vertical mid-line.
    var hero = root.querySelector('.jnh-hero');
    var heroBg = hero && hero.querySelector('.jnh-hero__bg');
    var gallery = hero && hero.querySelector('.jnh-gallery');
    if (heroBg && gallery) {
      var setHeroBgHeight = function () {
        var heroRect = hero.getBoundingClientRect();
        var galleryRect = gallery.getBoundingClientRect();
        var height = (galleryRect.top - heroRect.top) + galleryRect.height / 2;
        hero.style.setProperty('--jnh-hero-bg-h', Math.round(height) + 'px');
      };
      setHeroBgHeight();
      window.addEventListener('resize', setHeroBgHeight, { passive: true });
      window.addEventListener('load', setHeroBgHeight);
      if (document.fonts && document.fonts.ready) {
        document.fonts.ready.then(setHeroBgHeight);
      }
    }

    // Parallax on every background-image container (.jnh-parallax).
    var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var layers = [];
    root.querySelectorAll('.jnh-parallax').forEach(function (bg) {
      var medias = bg.querySelectorAll('img, video, svg');
      if (!medias.length) return;
      var strength = parseFloat(bg.getAttribute('data-parallax'));
      if (isNaN(strength)) strength = 0.6;
      layers.push({ bg: bg, medias: medias, strength: strength });
    });

    if (!reduceMotion && layers.length) {
      var ticking = false;
      var update = function () {
        ticking = false;
        var vh = window.innerHeight || document.documentElement.clientHeight;
        layers.forEach(function (layer) {
          var rect = layer.bg.getBoundingClientRect();
          if (rect.bottom < -200 || rect.top > vh + 200) return; // skip far-offscreen
          // shift: -1 (just entering at bottom) .. +1 (leaving at top)
          var shift = ((vh - rect.top) / (vh + rect.height)) * 2 - 1;
          var maxShift = rect.height * 0.22 * layer.strength; // stays within the 25% overflow
          var t = 'translate3d(0,' + (shift * maxShift).toFixed(1) + 'px,0)';
          for (var k = 0; k < layer.medias.length; k++) {
            layer.medias[k].style.transform = t;
          }
        });
      };
      var onScroll = function () {
        if (!ticking) { ticking = true; window.requestAnimationFrame(update); }
      };
      window.addEventListener('scroll', onScroll, { passive: true });
      window.addEventListener('resize', onScroll, { passive: true });
      update();
    }
  }

  document.querySelectorAll('.jnh-amb').forEach(init);
})();
